import React from "react";

const ShippingSelection = () => {
  return (
    <>
      <h1>
        Shipping <br /> Information
      </h1>
      <p>Please fill in the order details</p>
      <div className="mb-4">
        <select>
          <option value="">Country</option>
        </select>
      </div>
      <div className="mb-4">
        <select>
          <option value="">State</option>
        </select>
      </div>
      <div className=" position-relative  mb-4">
        <input type="text" placeholder="Address" />
        <svg
          className="arrow-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
        >
          <path
            d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
            fill="white"
          />
        </svg>
      </div>
      <div className="position-relative   mb-4 ">
        <input type="email" placeholder="Zip Code" />
        <svg
          className="arrow-icon"
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="24"
          viewBox="0 0 22 24"
          fill="none"
        >
          <path
            d="M21.0607 13.0607C21.6464 12.4749 21.6464 11.5251 21.0607 10.9393L11.5147 1.3934C10.9289 0.807611 9.97919 0.807611 9.3934 1.3934C8.80761 1.97919 8.80761 2.92893 9.3934 3.51472L17.8787 12L9.3934 20.4853C8.80761 21.0711 8.80761 22.0208 9.3934 22.6066C9.97919 23.1924 10.9289 23.1924 11.5147 22.6066L21.0607 13.0607ZM0 13.5H20V10.5H0V13.5Z"
            fill="white"
          />
        </svg>
      </div>
      <p>Select Shipping method</p>
      <div className="mb-4">
        <select>
          <option value="">DHL</option>
        </select>
      </div>
    </>
  );
};

export default ShippingSelection;
